<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-con">
            <div class="check-box">
              <label name="스마일 코멘트 템플릿" class="checkbox-s" v-for="(item, index) in contents" :key="index">
                <input type="radio" name="radio" :value="item" v-model="state.object" />
                <span class="check-txt">{{ item.content }}</span>
              </label>
            </div>
          </div>

          <BasicButton
            modal-btn
            @leftEvent="$emit('close')"
            @rightEvent="fnSelect"
            left-text="닫기"
            right-text="선택"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeMount, reactive } from 'vue';
import { isEmpty } from '@/common/utils/Util';
import { showTextModal } from '@/common/utils/ModalState';
import BasicButton from '@/components/common/layouts/BasicButton.vue';

const props = defineProps(['data']);
const emits = defineEmits(['close']);
const { fnCallBack, defaultValue, errorText, maxLength } = props.data;

const contents = computed(() => props.data?.contents);

const state = reactive({
  object: '',
  textInput: ''
});

onBeforeMount(() => {
  // 아무것도 없으면 초기화
  if (!props.data.comment.templateNo && !props.data.name && !props.data.comment.comment) {
    state.object = defaultValue;
  } else {
    // 아니면 선택한 조문글 템플릿으로 바인딩
    state.object = props.data.comment;
  }

  // 직접입력이면 기본값 넣고 textInput 바인딩
  if (props.data.comment.name === '직접입력') {
    state.object = defaultValue;
    state.textInput = props.data.textInput;
  }
});

const fnSelect = () => {
  fnCallBack(state.object);
  close();
};
const close = () => {
  setTimeout(() => {
    emits('close');
  }, 300);
};
</script>
<style scoped></style>
